import {Message} from 'element-ui';
let shortcuts = {};

/* 今天 */
shortcuts.today = {
    name:'today',
    text: '今天',
    onClick(picker) {
        picker.$emit('pick', [new Date(),new Date()]);
    }
};
/* 昨天 */
shortcuts.yesterday = {
    name:'yesterday',
    text: '昨天',
    onClick(picker) {
        const date = new Date();
        date.setTime(date.getTime() - 3600 * 1000 * 24);
        picker.$emit('pick', [date,date]);
    }
};
/*前3天 - 包含当日/今天 */
shortcuts.last3 =  {
    name:'last3',
    text: '最近3天',
    onClick(picker) {
        const date = new Date();
        let startDate = new Date(date.getTime() - 3600 * 1000 * 24 * 2);
        let endDate = new Date(date.getTime());
        picker.$emit('pick', [startDate,endDate]);
    }
};
/*前7天 - 包含当日/今天 */
shortcuts.last7 =  {
    name:'last7',
    text: '最近7天',
    onClick(picker) {
        const date = new Date();
        let startDate = new Date(date.getTime() - 3600 * 1000 * 24 * 6);
        let endDate = new Date(date.getTime());
        picker.$emit('pick', [startDate,endDate]);
    }
};
/*前14天 - 包含当日/今天 */
shortcuts.last14 =  {
    name:'last14',
    text: '最近14天',
    onClick(picker) {
        const date = new Date();
        let startDate = new Date(date.getTime() - 3600 * 1000 * 24 * 13);
        let endDate = new Date(date.getTime());
        picker.$emit('pick', [startDate,endDate]);
    }
};
/*前30天 - 包含当日/今天 */
shortcuts.last30 =  {
    name:'last30',
    text: '最近30天',
    onClick(picker) {
        const date = new Date();
        let startDate = new Date(date.getTime() - 3600 * 1000 * 24 * 29);
        let endDate = new Date(date.getTime());
        picker.$emit('pick', [startDate,endDate]);
    }
};
/*本周*/
shortcuts.thisWeek =   {
    name: 'thisWeek',
    text: '本周',
    onClick(picker) {
        // 本周：自然周，周一到周日
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth()+1;
        let day = date.getDate();
        let weekDay = date.getDay();
        let endDate = year+'-'+month+'-'+day;
        let startD = new Date(date.getTime()-1000*60*60*24*(weekDay===0?6:weekDay-1));
        let startDate = startD.getFullYear()+'-'+(startD.getMonth()+1)+'-'+startD.getDate();
        picker.$emit('pick', [startDate, endDate]);
    }
};
/*本月*/
shortcuts.thisMonth = {
    name: 'thisMonth',
    text: '本月',
    onClick(picker) {
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth()+1;
        let day = date.getDate();
        let startDate = year+'-'+month+'-1';
        let endDate = year+'-'+month+'-'+day;
        picker.$emit('pick', [startDate, endDate]);
    }
};
/*本季度*/
shortcuts.thisQuarter = {
    name: 'thisQuarter',
    text: '本季度',
    onClick(picker) {
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth()+1;
        let day = date.getDate();
        let startDate='';
        if([1,2,3].includes(month)){
            startDate = year+'-01-01';
        }else if([4,5,6].includes(month)){
            startDate = year+'-04-01';
        }else if([7,8,9].includes(month)){
            startDate = year+'-07-01';
        }else if([10,11,12].includes(month)){
            startDate = year+'-10-01';
        }
        let endDate = year+'-'+month+'-'+day;
        picker.$emit('pick', [startDate, endDate]);
    }
};
/*本年*/
shortcuts.thisYear = {
    name: 'thisYear',
    text: '本年',
    onClick(picker) {
        let date = new Date();
        let year = date.getFullYear();
        let startDate= year+'-01-01';
        let endDate = year+'-12-31';
        picker.$emit('pick', [startDate, endDate]);
    }
};
/*上周*/
shortcuts.lastWeek =   {
    name:'lastWeek',
    text: '上周',
    onClick(picker) {
        // 上周：自然周，周一到周日
        let date = new Date(new Date().getTime()-1000*60*60*24*7);
        let weekDay = date.getDay();
        let startDate = new Date(date.getTime()-1000*60*60*24*(weekDay===0?6:weekDay-1));
        let endDate = new Date(startDate.getTime() + 1000*60*60*24*6);
        picker.$emit('pick', [startDate, endDate]);
    }
};
/*上月*/
shortcuts.lastMonth = {
    name:'lastMonth',
    text: '上月',
    onClick(picker) {
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth();
        let startDate = new Date(year+'-'+month+'-01');
        let endDate = new Date(new Date(year+'-'+(month+1)+'-01').getTime()-1000*60*60*24);
        picker.$emit('pick', [startDate, endDate]);
    }
};
/*上季度*/
shortcuts.lastQuarter = {
    name:'lastQuarter',
    text: '上季度',
    onClick(picker) {
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth()+1;

        let startDate='';
        let endDate = '';
        if([1,2,3].includes(month)){
            startDate = (year-1)+'-10-01';
            endDate = (year-1)+'-12-31';
        }else if([4,5,6].includes(month)){
            startDate = year+'-01-01';
            endDate = year+'-03-31';
        }else if([7,8,9].includes(month)){
            startDate = year+'-04-01';
            endDate = year+'-06-30';
        }else if([10,11,12].includes(month)){
            startDate = year+'-07-01';
            endDate = year+'-09-30';
        }
        picker.$emit('pick', [startDate, endDate]);
    }
};

/*去年*/
shortcuts.lastYear = {
    name:'lastYear',
    text: '去年',
    onClick(picker) {
        let date = new Date();
        let year = date.getFullYear()-1;
        let startDate= year+'-01-01';
        let endDate = year+'-12-31';
        console.log('lastYear pick',startDate, endDate);
        picker.$emit('pick', [startDate, endDate]);
    }
};


shortcuts.getYesterday = (lastDate)=>{
    return {
        name:'yesterday',
        text: '昨天',
        onClick(picker) {
            let lastTime = new Date(lastDate);
            const date = new Date();
            let startDate = date.setTime(date.getTime() - 3600 * 1000 * 24);

            if(lastTime.getTime()<=new Date(startDate).getTime()){
                Message.error('所选筛选在该日期无任何数据');
                // picker.$emit('pick', [lastTime, lastTime]);
            }else{
                picker.$emit('pick', [startDate,startDate]);
            }
        }
    }
};
shortcuts.getLast7 = (lastDate)=>{
    return {
        name:'last7',
        text: '前7天',
        onClick(picker) {
            const date = new Date();
            let lastTime = new Date(lastDate);
            let startDate = new Date(date.getTime() - 3600 * 1000 * 24 * 7);
            let endDate = new Date(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', [startDate,endDate]);
            if(lastTime.getTime()<=startDate.getTime()){
                Message.error('所选筛选在该日期无任何数据');
                // picker.$emit('pick', [lastTime, lastTime]);
            }else if(lastTime.getTime()<=endDate.getTime()){
                picker.$emit('pick', [startDate, lastTime]);
            }else{
                picker.$emit('pick', [startDate, endDate]);
            }
        }
    }
};
shortcuts.getLast14 = (lastDate)=>{
    return {
        name:'last14',
        text: '前14天',
        onClick(picker) {
            const date = new Date();
            let lastTime = new Date(lastDate);
            let startDate = new Date(date.getTime() - 3600 * 1000 * 24 * 14);
            let endDate = new Date(date.getTime() - 3600 * 1000 * 24);
            if(lastTime.getTime()<=startDate.getTime()){
                Message.error('所选筛选在该日期无任何数据');
                // picker.$emit('pick', [lastTime, lastTime]);
            }else if(lastTime.getTime()<=endDate.getTime()){
                picker.$emit('pick', [startDate, lastTime]);
            }else{
                picker.$emit('pick', [startDate, endDate]);
            }
        }
    }
};
shortcuts.getLast30 = (lastDate)=>{
    return {
        name:'last30',
        text: '前30天',
        onClick(picker) {
            const date = new Date();
            let lastTime = new Date(lastDate);
            let startDate = new Date(date.getTime() - 3600 * 1000 * 24 * 30);
            let endDate = new Date(date.getTime() - 3600 * 1000 * 24);
            if(lastTime.getTime()<=startDate.getTime()){
                Message.error('所选筛选在该日期无任何数据');
                // picker.$emit('pick', [lastTime, lastTime]);
            }else if(lastTime.getTime()<=endDate.getTime()){
                picker.$emit('pick', [startDate, lastTime]);
            }else{
                picker.$emit('pick', [startDate, endDate]);
            }
        }
    }
};

shortcuts.getThisWeek = (lastDate)=>{
    return {
        text: '本周',
        onClick(picker) {
            // 本周：自然周，周一到周日
            let lastTime = new Date(lastDate);
            let date = new Date();
            let year = date.getFullYear();
            let month = date.getMonth()+1;
            let day = date.getDate();
            let weekDay = date.getDay();
            let endDate = year+'-'+month+'-'+day;
            let startD = new Date(date.getTime()-1000*60*60*24*(weekDay===0?6:weekDay-1));
            let startDate = startD.getFullYear()+'-'+(startD.getMonth()+1)+'-'+startD.getDate();

            if(lastTime.getTime()<=new Date(startDate).getTime()){
                picker.$emit('pick', [lastTime, lastTime]);
            }else if(lastTime.getTime()<=new Date(endDate).getTime()){
                picker.$emit('pick', [startDate, lastDate]);
            }else{
                picker.$emit('pick', [startDate, endDate]);
            }

        }
    }
};
shortcuts.getThisMonth = (lastDate)=>{
    return {
        text: '本月',
        onClick(picker) {
            let lastTime = new Date(lastDate);
            let date = new Date();
            let year = date.getFullYear();
            let month = date.getMonth()+1;
            let startDate = year+'-'+month+'-1';

            if(lastTime.getTime()<=new Date(startDate).getTime()){
                picker.$emit('pick', [lastTime, lastTime]);
            }else{
                picker.$emit('pick', [startDate, lastDate]);
            }

        }
    }
};
shortcuts.getThisQuarter = (lastDate)=>{
    return {
        text: '本季度',
        onClick(picker) {
            let lastTime = new Date(lastDate);
            let date = new Date();
            let year = date.getFullYear();
            let month = date.getMonth()+1;
            let startDate='';
            if([1,2,3].includes(month)){
                startDate = year+'-01-01';
            }else if([4,5,6].includes(month)){
                startDate = year+'-04-01';
            }else if([7,8,9].includes(month)){
                startDate = year+'-07-01';
            }else if([10,11,12].includes(month)){
                startDate = year+'-10-01';
            }

            if(lastTime.getTime()<=new Date(startDate).getTime()){
                picker.$emit('pick', [lastTime, lastTime]);
            }else{
                picker.$emit('pick', [startDate, lastDate]);
            }

        }
    }
};
shortcuts.getThisYear = (lastDate)=>{
    return {
        text: '本年',
        onClick(picker) {
            let lastTime = new Date(lastDate);
            let date = new Date();
            let year = date.getFullYear();
            let startDate= year+'-01-01';

            if(lastTime.getTime()<=new Date(startDate).getTime()){
                picker.$emit('pick', [lastTime, lastTime]);
            }else{
                picker.$emit('pick', [startDate, lastDate]);
            }

        }
    }
};

shortcuts.getLastWeek = (lastDate)=>{
    return {
        name:'lastWeek',
        text: '上周',
        onClick(picker) {
            // 上周：自然周，周一到周日
            let lastTime = new Date(lastDate);
            let date = new Date(new Date().getTime()-1000*60*60*24*7);
            let weekDay = date.getDay();
            let startDate = new Date(date.getTime()-1000*60*60*24*(weekDay===0?6:weekDay-1));
            let endDate = new Date(startDate.getTime() + 1000*60*60*24*6);
            if(lastTime.getTime()<=startDate.getTime()){
                Message.error('所选筛选在该日期无任何数据');
                // picker.$emit('pick', [lastTime, lastTime]);
            }else if(lastTime.getTime()<=endDate.getTime()){
                picker.$emit('pick', [startDate, lastTime]);
            }else{
                picker.$emit('pick', [startDate, endDate]);
            }
        }
    }
};
shortcuts.getLastMonth = (lastDate)=>{
    return {
        name:'lastMonth',
        text: '上月',
        onClick(picker) {
            let lastTime = new Date(lastDate);
            let date = new Date();
            let year = date.getFullYear();
            let month = date.getMonth();
            let startDate = new Date(year+'-'+month+'-01');
            let endDate = new Date(new Date(year+'-'+(month+1)+'-01').getTime()-1000*60*60*24);
            if(lastTime.getTime()<=startDate.getTime()){
                Message.error('所选筛选在该日期无任何数据');
                // picker.$emit('pick', [lastTime, lastTime]);
            }else if(lastTime.getTime()<=endDate.getTime()){
                picker.$emit('pick', [startDate, lastTime]);
            }else{
                picker.$emit('pick', [startDate, endDate]);
            }
        }
    }
};
shortcuts.getLastQuarter = (lastDate)=>{
    return {
        name:'lastQuarter',
        text: '上季度',
        onClick(picker) {
            let lastTime = new Date(lastDate);
            let date = new Date();
            let year = date.getFullYear();
            let month = date.getMonth()+1;

            let startDateStr='';
            let endDateStr = '';
            if([1,2,3].includes(month)){
                startDateStr = (year-1)+'-10-01';
                endDateStr = (year-1)+'-12-31';
            }else if([4,5,6].includes(month)){
                startDateStr = year+'-01-01';
                endDateStr = year+'-03-31';
            }else if([7,8,9].includes(month)){
                startDateStr = year+'-04-01';
                endDateStr = year+'-06-30';
            }else if([10,11,12].includes(month)){
                startDateStr = year+'-07-01';
                endDateStr = year+'-09-30';
            }
            let startDate = new Date(startDateStr);
            let endDate = new Date(endDateStr);
            if(lastTime.getTime()<=startDate.getTime()){
                Message.error('所选筛选在该日期无任何数据');
                // picker.$emit('pick', [lastTime, lastTime]);
            }else if(lastTime.getTime()<=endDate.getTime()){
                picker.$emit('pick', [startDate, lastTime]);
            }else{
                picker.$emit('pick', [startDate, endDate]);
            }
        }
    }
};





export default shortcuts;
